/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  TodaysAttnd
} from '../../schema'


/**
 * List all attendances of an employee
 */
export const listTodaysAttnds = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TodaysAttnd[]>> => {
    return axios.get(
      `/retrieveattendance/`,options
    );
  }


export const getListTodaysAttndsQueryKey = () => [`/retrieveattendance/`];

    
export type ListTodaysAttndsQueryResult = NonNullable<Awaited<ReturnType<typeof listTodaysAttnds>>>
export type ListTodaysAttndsQueryError = AxiosError<unknown>

export const useListTodaysAttnds = <TData = Awaited<ReturnType<typeof listTodaysAttnds>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTodaysAttnds>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTodaysAttndsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTodaysAttnds>>> = ({ signal }) => listTodaysAttnds({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listTodaysAttnds>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

